/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import { RouteConfig } from 'vue-router'
import API from '@core/services/API'
import AppForm from '@core/components/AppForm.vue'
import { IDateService } from '@master/services/IDateService'
import { namespace } from 'vuex-class'
import AppSectionNavi from '@core/components/AppSectionNavi.vue'
import { ClientManagementRoutes } from '../router/index'

const clientInfoStore = namespace('ClientInfoStore')

@Component({
  components: {
    AppForm,
    AppSectionNavi
  }
})
export class ClientInfoMixin extends Vue {
  @inject()
  protected dateService: IDateService

  @inject()
  protected $api: API

  @clientInfoStore.State
  private readOnly

  @clientInfoStore.Mutation
  private setReadOnly

  // Version 2 for client dto
  @clientInfoStore.State
  private clientDto

  @clientInfoStore.Action
  private retrieveClientDTOV2

  formattedDate (unixTime: number | string) {
    return this.dateService.format(Number(unixTime), 'YYYY-MM-DD')
  }

  get sections (): Array<RouteConfig> {
    return ClientManagementRoutes.map(route => {
      if (route.name === 'AML / CKA / AI / OI Monitoring' && !this.isSuperUser) {
        return null
      }
      return route
    }).filter(route => !!route)
  }

  get parentPath () {
    const path = this.$router.currentRoute.matched[0].path
    const param = this.$router.currentRoute.params.clientOid
    return path.replace(':clientOid', param)
  }

  get curUser () {
    return this.$store.getters.currentUser
  }

  get isSuperUser () {
    return this.curUser?.isSuperUser || false
  }

  get policyOid () {
    return this.$route.params.policyOid
  }

  get clientOid () {
    return this.$route.params.clientOid
  }

  @Watch('isSuperUser')
  suUpdated (su) {
    this.setReadOnly(!su)
  }

  async mounted () {
    // await this.fetchData()
    // if (!this.productList.getFullList.length) await this.fetchProductList()
    // if (this.clientProfile?.hrcRoles?.length) this.parseHrcRoles()
    this.setReadOnly(!this.isSuperUser)
    await this.retrieveClientDTOV2(this.clientOid)
  }
}
